<template>
    <div class="sidebar" :current="current">
        <div class="app-title section-header">Water Town</div>
        <div class="app-header">Water Tower Control</div>
        <div class="app-version" id="app-version"></div>
        <div class="flex-separator"></div>
        <div id="sidebar-pump" :clickable="canChangeTabs" :class="['menu',current=='pumpcontrol'?'active':'inactive']" @click="goTo('pumpcontrol')">Pump Control</div>
        <div id="sidebar-messages" :clickable="canChangeTabs" :class="['menu',current=='messages'?'active':'inactive']" @click="goTo('messages')"><span class="tablabel" :messages="messages.unread()>0">Messages <span class="badge">{{messages.unread()}}</span></span></div>
    </div>
</template>

<script>

import messages from '@/lib/messages.js'
import simulation from '@/lib/simulation.js'

export default {
  name: 'sidebar',
  data: function () {
    return {
      messages: messages,
      simulation: simulation
    }
  },
  mounted: function () {
    const self = this
    messages.addMessageListener(function (msg) {
      if (self) {
        self.$forceUpdate()
      }
    })
  },
  methods: {
    goTo: function (section) {
      const paths = document.location.hash.replace('#', '').split('/')
      if (!this.canChangeTabs) {
        return
      }
      if (paths.length > 3) {
        const current = paths.pop()
        if (current === section) {
          return
        }
      }
      if (section === 'pumpcontrol' && !simulation.started) {
        this.$emit('start', simulation.challengeNumber)
        return
      }
      paths.push(section)
      this.$router.push(paths.join('/'))
    }
  },
  props: {
    current: String
  },
  computed: {
    canChangeTabs: function () {
      return simulation.challengeNumber >= 1 || (simulation.data.tutorialId === 0)
    }
  }
}
</script>

<style scoped lang="scss">
.sidebar{
    width: 150px;
    min-width: 150px;
    background-color: #202020;
    color: #fff;
    text-align: left;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    > div{
        padding: 0 16px;
    }
    .app-title{
        text-transform: uppercase;
        font-weight: bold;
        margin: 16px;
        padding: 2px 0 18px 0;
        border-bottom: 2px solid #0259B7;
        font-size: 14px;
    }
    .app-header{
        font-weight: bold;
        font-size: 28px;
    }
    .app-version{
        border-radius: 3px;
        display: inline-block;
        padding: 2px 4px;
        margin: 8px 16px;
        width: 70px;
        span{
            font-weight: bold;
        }
    }
    .menu{
        height: 40px;
        line-height: 40px;
        text-transform: uppercase;
        font-size: 12px;
        font-weight: bold;
        transition: background-color 0.2s;
        color: #aaa;
        &[clickable='true']{
          cursor: pointer;
          color: #fff;
          &.inactive:hover{
            background-color: #2C2C2C;
          }
        }
        &.active{
            background-color: #333333;
            border-left: 2px solid #00B5E2;
        }
    }
}
.badge{
  opacity: 0;
  transition: linear .5s;
}
.tablabel{
  display: flex;
  justify-content:space-between;
  align-items:center;

}
.tablabel[messages=true]{
  .badge{
    opacity: 1;
  }
}
.sidebar[current='pumpcontrol']{
  .tablabel[messages=true]{
    animation: shake;
    -webkit-animation-duration: .2s;
    animation-duration: .2s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
    -webkit-animation-timing-function: linear;
    animation-timing-function: linear;
    animation-iteration-count: 10;
    -webkit-animation-iteration-count: 10;
  }
}

@media (max-height: 800px) {
  .sidebar{
    min-width: 140px;
    width: 140px;
    .app-header{
      font-size: 24px;
    }
  }
}
@media (max-height: 700px){
  .sidebar{
    min-width: 125px;
    width: 125px;
    .app-header{
      font-size: 20px;
    }
    .menu {
      font-size: 12px;
    }
    > div{
        padding: 0 12px;
    }
    .app-title{
        margin: 12px;
    }
    .app-version{
        margin: 8px 12px;
    }
  }
}
@media (max-height: 660px){
  .sidebar{
    min-width: 118px;
    width: 118px;
    .app-header{
      font-size: 18px;
    }
    .app-version{
      font-size: 14px;
    }
    .menu {
      height: 36px;
      line-height: 36px;
    }
  }
}
</style>
